import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FooterComponent } from '@core/component/footer/footer.component';
import { MainNavComponent } from 'src/app/core/component/main-nav/main-nav.component';
import { DemoModalComponent } from '@core/component/demo-modal/demo-modal.component';
import { CookieConsentComponent } from '@core/component/cookie-consent/cookie-consent.component';
import { DemoService } from 'src/app/core/service/demo.service';
import { AnalyticsService } from '@core/service/analytics.service';

@Component({
  imports: [RouterOutlet, MainNavComponent, FooterComponent, DemoModalComponent, CookieConsentComponent],
  providers: [AnalyticsService],
  templateUrl: './main-shell.component.html',
  styleUrl: './main-shell.component.scss',
})
export class MainShellComponent {
  constructor(
    private readonly demoService: DemoService,
    readonly analytics: AnalyticsService
  ) {}

  openDemo(): void {
    const source = 'footer';
    this.analytics.trackEvent('demo_open', { source });
    this.demoService.open(source);
  }
}
